module.exports = __webpack_public_path__ + "img/zhlc-2.d89a00d7.png";